var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f7-chip',{class:'credit-tag ' + _vm.aligned,attrs:{"slot":_vm.slotpos,"icon":"icon-thumbify","text":_vm.events ? _vm.events[_vm.eventName] : _vm.amount,"tooltip":_vm.$t('credit-collecting')
      .replace('XX', _vm.events ? _vm.events[_vm.eventName] : _vm.amount)
      .replace('YY', _vm.$t('events.' + _vm.eventName).toLowerCase())},slot:_vm.slotpos})],1)}
var staticRenderFns = []

export { render, staticRenderFns }